module.exports = __webpack_public_path__ + "img/678CBADA.7dd40ba5.png";